import { Component, OnInit, Inject } from '@angular/core';
import { CommonService } from '../../services';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { CurrentUserModel } from '../../models/account-ledger.model';

@Component({
  selector: 'app-confirm-mnpid',
  templateUrl: './confirm-mnpid.component.html',
  styleUrls: ['./confirm-mnpid.component.css']
})
export class ConfirmMnpidComponent implements OnInit {
  currentUserModel: CurrentUserModel;
  isAU: boolean;
  url: string;
  urlAU = 'https://creative.dickerdata.com.au/2020/01-Jan/Microsoft/115/MST-115-2801eDM.html?utm_source=New+Software+List+-Sep+16&utm_campaign=5291cdd3cc-EMAIL_CAMPAIGN_2020_01_28_04_15&utm_medium=email&utm_term=0_5f29a963b3-5291cdd3cc-';
  urlNZ = 'https://creative.dickerdata.com.au/2020/01-Jan/DDNZ/Microsoft/009/MSTNZ-009-3001eDM.html';
  constructor(
    public commonService: CommonService,
    public dialogRef: MatDialogRef<ConfirmMnpidComponent>,
    private authService: AuthService,

  ) { }

  ngOnInit() {
    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;
      this.isAU = this.currentUserModel.isAU;
      if (this.isAU === true) {
        this.url = this.urlAU;
      } else {
        this.url = this.urlNZ;
      }
      // this.isAU = false;
    },
      (error: any) => {
        console.info(error);
      });
  }

  onNoClick(): void{
    this.dialogRef.close();
  }

}
